import { createRouter, createWebHistory } from 'vue-router';
import { palettenkontoRoutes } from '@/modules/palettenkonto/routes/index';

const router = createRouter({
  history: createWebHistory(),
  routes: [...palettenkontoRoutes, { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/NotFound.vue') }],
});

// router.beforeEach((to, _from, next) => {
//   const publicPages = ['/login', '/logout'];
//   const authRequired = !publicPages.includes(to.path);

//   let loggedIn = false;

//   if (localStorage.getItem('wmsUser') || sessionStorage.getItem('wmsUser')) {
//     loggedIn = true;
//   }

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// });

export default router;
